var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM12.4041 5.88976C12.6272 5.6666 12.6272 5.3048 12.4041 5.08164C12.1809 4.85848 11.8191 4.85848 11.5959 5.08164L6.28571 10.3919L4.40406 8.51021C4.1809 8.28705 3.8191 8.28705 3.59594 8.51021C3.37278 8.73337 3.37278 9.09518 3.59594 9.31833L5.88165 11.604C6.10481 11.8272 6.46662 11.8272 6.68978 11.604L12.4041 5.88976Z",
    fill: "#009640"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCorrect);
export default __webpack_public_path__ + "static/media/ic_correct.5817ce2455aceb97857d18fe79112d09.svg";
export { ForwardRef as ReactComponent };